import * as Common from '@/tenantCatalog/common';

export class Customize extends Common.StateObject{
  constructor(){
    super('Customize');
    this.state = CustomizeStatus.notPosted;
    this.workflowStateId = CustomizeStatus.notPosted;
  }
  public id :number = 0;
  public tenant :Common.Tenant = null;
  public customizeContent :string = "";
  public estimateNo :string = "";
  public orderedDate :Date = null;
  public releaseDate :Date = null;
  public developAmount :number = 0;
  public projectAmount :number = 0;
  public maintenanceAmount :number =0;
  public maintenanceStartMonth :Date = null;
  
  public copy():any {
    const temp = super.copy() as Customize;
    temp.id = 0;
    temp.state = Common.CustomizeStatus.notPosted;
    temp.workflowStateId = CustomizeStatus.notPosted;
    return temp;
  }
}

export enum CustomizeStatus{
  notPosted = 1, // 未確定
  posted = 2,  // 確定
  all = notPosted | posted,
}

export class CustomizeQuery extends Common.LoadQuery {
  constructor(){
    super('CustomizeQuery',Customize);
    this.sort = 'id';    
  }
  public tenantId:string = '';
  public tenantName :string = '';
  public customizeContent:string='';
  public estimateNo:string='';
  public orderedDateFrom:Date=null;
  public orderedDateTo:Date=null;
  public releaseDateFrom:Date=null;
  public releaseDateTo:Date=null;

  public state :CustomizeStatus = CustomizeStatus.all;
}